import React from "react";
import "./styles.scss";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { useSelector } from "react-redux";
import { FormHeader, GazettePreviewCard, Tag } from "..";

const GazetteDetailsViewCard = (props) => {
  const { tagsList } = useSelector(({ tagsReducer }) => tagsReducer);

  return (
    <>
      <div className={`gazette-details-view-card-wrapper`}>
        <div className={"gvcw-logo"}>
          <img src={require("../../assets/img/gov_logo.png")} alt={"job-img"} />
        </div>
        <div className="gvcw_card">
          <div className={"gvcw__c-body"}>
            {/* <div
              style={{
                width: "100%",
                paddingBottom: "16px",
                gap: "8px",
                // marginBottom: "px",
              }}
            > */}

            <FormHeader
              data={{
                formHeader: props?.titleEn,
                lan: "en",
                size: "xs xx",
              }}
            />
            <FormHeader
              data={{
                formHeader: props?.titleSi,
                lan: "si",
                size: "xs",
              }}
            />

            {/* </div> */}
            <div
              className="gvcw-Tags-wrapper d-flex flex-row  "
              style={{ gap: "10px" }}
            >
              <Tag
                data={{
                  isIcon: false,

                  type: "gray",

                  // tagName: moment().isAfter(moment(props?.gazetteDate))
                  //   ? "Expired"
                  //   : moment(props?.gazetteDate).format("DD-MMM-YYYY"),
                  tagName: moment(props?.gazetteDate).format("DD-MMM-YYYY"),
                }}
              />
              {/* <Tag
                data={{
                  isIcon: false,
                  type: "views_tag",
                  // tagName: data?.tags?.[0],
                  tagName: props?.organization,
                }}
              /> */}
              {Array.isArray(props?.organization) &&
                props.organization.length > 0 && (
                  <div className="d-flex flex-wrap" style={{ gap: "4px" }}>
                    {props.organization.map((tagId, index) => {
                      const tagData = tagsList.find((t) => t.tag_id === tagId);
                      return (
                        <Tag
                          key={index}
                          data={{
                            isIcon: false,
                            type: "gray",
                            tagName: tagData?.tag_name || "",
                          }}
                        />
                      );
                    })}
                  </div>
                )}
              <Tag
                data={{
                  isIcon: true,
                  tagIcon: "eye",
                  tagName: props?.views,
                  type: "views_tag",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div
        className="gdcw-buttons-wrapper d-flex flex-column mt-3"
        style={{ gap: "10px" }}
      >
        {props?.attachmentSI?.length > 0 && (
          <GazettePreviewCard
            title={"Government Gazette (Sinhala)"}
            isExpand={true} //default open when page load
            attachments={props?.attachmentSI}
            onClickDownload={props?.onClickDownloadSI}
            // onClickExpand={""}
          />
        )}

        {props?.attachmentEN?.length > 0 && (
          <GazettePreviewCard
            title={"Government Gazette (English)"}
            isExpand={false}
            attachments={props?.attachmentEN}
            onClickDownload={props?.onClickDownloadEN}
            // onClickExpand={""}
          />
        )}

        {props?.attachmentTA?.length > 0 && (
          <GazettePreviewCard
            title={"Government Gazette (Tamil)"}
            isExpand={false}
            attachments={props?.attachmentTA}
            onClickDownload={props?.onClickDownloadTA}
            // onClickExpand={""}
          />
        )}

        {props?.procurementSI?.length > 0 && (
          <GazettePreviewCard
            title={"Procurement Notice (Sinhala)"}
            isExpand={false}
            attachments={props?.procurementSI}
            onClickDownload={props?.onClickProcurementDownloadSI}
            // onClickExpand={""}
          />
        )}
        {props?.procurementEN?.length > 0 && (
          <GazettePreviewCard
            title={"Procurement Notice (English)"}
            isExpand={false}
            attachments={props?.procurementEN}
            onClickDownload={props?.onClickProcurementDownloadEN}
            // onClickExpand={""}
          />
        )}
        {props?.procurementTA?.length > 0 && (
          <GazettePreviewCard
            title={"Procurement Notice (Tamil)"}
            isExpand={false}
            attachments={props?.procurementTA}
            onClickDownload={props?.onClickProcurementDownloadTA}
            // onClickExpand={""}
          />
        )}
      </div>
    </>
  );
};

export default withRouter(GazetteDetailsViewCard);
